'use client';

import { BaseMarketingSection } from '@/components/organisms';
import { BaseMarketingSectionSkeleton } from '@/components/organisms/skeletons/BaseMarketingSectionSkeleton';
import { useMarketingInfoQuery } from '@/hooks/league/useMarketingInfoQuery';

export const ToursAndSeriesSection = () => {
	const { data: toursAndSeriesInfo, isFetching } = useMarketingInfoQuery('1');
	const modules = toursAndSeriesInfo?.data?.modules;

	if (isFetching) {
		return <BaseMarketingSectionSkeleton />;
	}

	if (!modules || modules.length === 0) return null;

	return <BaseMarketingSection marketingData={modules ?? []} marketingTitle="Tours & Series" />;
};
